import styled from "@emotion/styled";
import {Button} from "@mui/material";
import {ReactComponent as GameLogo} from "assets/img/game_logo.svg";
import {observer} from "mobx-react";
import React, {SyntheticEvent} from "react";
import {useI18n} from "data/hooks";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	height: 100%;
	min-height: 500px;
`;

const Buttons = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 12px;
	width: 100%;

	button {
		width: 100%;
		font-size: 16px;
		text-transform: capitalize;
	}
`;

const Texts = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 16px;

	.title {
		color: #ffffff;
		text-align: center;
		font-size: 20px;
		font-style: normal;
		font-weight: 600;
		line-height: 140%; /* 28px */
	}

	.text {
		color: #ffffff;
		text-align: center;
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: 140%; /* 22.4px */
	}
`;

interface IProps {
	onPlay: (e: SyntheticEvent<HTMLButtonElement>) => void;
	onGuide: (e: SyntheticEvent<HTMLButtonElement>) => void;
}

export const ModalTutorialStepOne: React.FC<IProps> = observer(({onPlay, onGuide}) => {
	const i18n = useI18n();
	return (
		<Wrapper>
			<GameLogo />

			<Texts>
				<p className="title">{i18n.t("tutorial.welcome.title", "Welcome!")}</p>

				<p className="text">
					{i18n.t(
						"tutorial.welcome.description",
						`Welcome to fantasy Spinball, where fantasy baseball meets spin the wheel. In
					this tutorial, we'll guide you through mastering the game and maximizing your
					fantasy points.`
					)}
				</p>
			</Texts>

			<Buttons>
				<Button variant="contained" color="secondary" onClick={onGuide}>
					{i18n.t("tutorial.welcome.first_button", "Guide")}
				</Button>
				<Button variant="contained" color="primary" onClick={onPlay}>
					{i18n.t("tutorial.welcome.second_button", "Play")}
				</Button>
			</Buttons>
		</Wrapper>
	);
});
